import React, {useEffect, useState} from 'react';
import AnimatedRow from "../../../../../ui/AnimatedRow";
import AgDiv from "../../../../../ui/divs/AgDiv";
import {ISubcontractor} from "../../../../../../utils/interfaces/lwg_dashboard/reports/workings/ISubcontractor";
import SubcontractorRow from "./SubcontractorRow";

interface Props {
    scrollableHeight?: number;
    subcontractors: ISubcontractor[] | undefined,
    totalWorkedSqm: number | undefined;
}

const SubContractorList = ({scrollableHeight = 100, subcontractors: initialObjs, totalWorkedSqm}: Props) => {

    const [objs, setObjs] = useState(initialObjs)
    const [filteredData, setFilteredData] = useState<ISubcontractor[] | undefined>(objs);


    useEffect(() => {
        if (objs) {
            setFilteredData(objs);
        }
    }, [objs]);

    useEffect(() => {
        setObjs(initialObjs)
    }, [initialObjs]);


    const mapped_data =
        filteredData?.map((obj: ISubcontractor, index: any) =>
            <AnimatedRow key={obj.id} index={index / 3}>
                <SubcontractorRow subcontractor={obj}/>
            </AnimatedRow>
        )

    const [totalPcs, setTotalPcs] = useState<number>()
    const [totalSqm, setTotalSqm] = useState<number>()
    const [totalPcsCoeff, setTotalPcsCoeff] = useState<number>()
    useEffect(() => {
        if (objs) {
            const total_pcs = objs.reduce((accumulator: any, object: ISubcontractor) => {
                return accumulator + object.worked_pcs
            }, 0);
            const total_sqm = objs.reduce((accumulator: any, object: ISubcontractor) => {
                return accumulator + object.worked_sqm
            }, 0);
            const total_pcs_coeff = objs.reduce((accumulator: any, object: ISubcontractor) => {
                return accumulator + (object.worked_pcs * 1.2);
            }, 0);
            setTotalPcs(total_pcs);
            setTotalSqm(total_sqm);
            setTotalPcsCoeff(total_pcs_coeff);

        }

    }, [objs]);

    return (
        <>
            <div className="p-4">
                <div
                    style={{
                        height: `calc(${scrollableHeight}vh - 250px)`,
                        overflowY: 'auto',
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        minWidth: '100%',
                        scrollbarWidth: 'auto',
                        scrollbarColor: '#02959c transparent',
                    }}
                    className='scroll-content no-scrollbar'
                >
                    <div className='flex flex-row capitalize font-bold'>
                        <AgDiv label={'people_name'}
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivHeader'}
                        />

                        <AgDiv label={'lwg_site_name'}
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivHeader'}
                        />

                        <AgDiv label='sqm_produced'
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivHeader'}
                        />

                        <AgDiv label='pcs_produced'
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivHeader'}
                        />

                        <AgDiv label='lwg_working_description'
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivHeader'}
                        />

                        <AgDiv label='coeff'
                               value={''}
                               minWidth="80px"
                               maxWidth="80px"
                               className={'AgDivHeader'}
                        />
                        <AgDiv label='PEZZI X 1.20' value={''}
                               minWidth="260px" maxWidth="260px" className={'AgDivHeader'}/>
                    </div>
                    <div className={''}>
                        {mapped_data}
                    </div>
                    <div className='flex flex-row'>
                        <AgDiv label=''
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'agDiv_transparent_div'}
                        />

                        <AgDiv label=''
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'agDiv_transparent_div'}
                        />

                        <AgDiv label=''
                               value={totalSqm && totalSqm.toFixed(2)}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivFooter'}
                        />

                        <AgDiv label=''
                               value={totalPcs && totalPcs.toFixed(2)}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'AgDivFooter'}
                        />

                        <AgDiv label=''
                               value={''}
                               minWidth="320px"
                               maxWidth="320px"
                               className={'agDiv_transparent_div'}
                        />

                        <AgDiv label=''
                               value={''}
                               minWidth="80px"
                               maxWidth="80px"
                               className={'agDiv_transparent_div'}
                        />
                        <AgDiv label=''
                               value={totalPcsCoeff && totalPcsCoeff.toFixed(2)}
                               minWidth="260px" maxWidth="260px" className={'AgDivFooter'}/>
                    </div>

                </div>


            </div>
        </>

    );
};

export default SubContractorList;